import { useDialogContext } from "@ariakit/react";
import { useCallback } from "react";
import { toast } from "react-hot-toast";
import { useLocation } from "wouter";

export type SuccessReaction = {
  message?: string;
  navigateTo?: string;
};

export function useHandleSuccess() {
  const dialog = useDialogContext();
  const [_, navigate] = useLocation();

  return useCallback(
    (reaction?: SuccessReaction) => {
      const { message, navigateTo } = reaction ?? {};

      dialog?.hide();

      if (navigateTo) {
        navigate(navigateTo, { transition: true });
      }

      if (message) {
        toast(message);
      }
    },
    [navigate, dialog],
  );
}
